import React, { useState } from "react";
import { Box, List, ListItem, Divider } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { axiosInstance } from "src/api/config/axiosInstance";
import { useSnackbar } from "notistack";

//MPOGLU;448052;06032025
interface PatientCareNursePlanAddProps {
  pcsid: number | null; // null olabilir
  setDialogTreeOpen: (open: boolean) => void;
  newPlan?: boolean;
  onTimeSelected?: (time: number, pcsid: number | null) => void; // pcsid null olabilir
  selectedPlan?: string; // Seçili plan adı
  currentPeriod?: number; // Mevcut period (dakika cinsinden)
  selectedRowData?: any; // Seçilen row'un verileri
  onSuccess?: () => void; // Callback for successful operations
}

const PatientCareNursePlanAdd: React.FC<PatientCareNursePlanAddProps> = ({
  pcsid,
  setDialogTreeOpen,
  newPlan,
  onTimeSelected,
  selectedPlan,
  currentPeriod,
  selectedRowData,
  onSuccess,
}) => {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();

  const handleTimeClick = async (time: any) => {
    setSelectedTime(time);

    if (selectedRowData && newPlan && pcsid) {
      try {
        const requestData = {
          PncpId: pcsid,
          Date: new Date().toISOString().slice(0, 10),
          Period: time * 60
        };

        const response = await axiosInstance.post('nurse/api/PatientNurseCarePlan/AddPatientNurseCarePlanDetailPeriods', requestData);

        if (response.status === 200) {
          enqueueSnackbar(t("patient-care.new-period-planning-added-successfully"), { variant: 'success' });
          if (onSuccess) {
            onSuccess();
          }
        } else {
          console.error("Failed to add new period planning");
          enqueueSnackbar(t("patient-care.new-period-planning-add-failed"), { variant: 'error' });
        }
      } catch (error) {
        console.error("Error adding new period planning:", error);
        enqueueSnackbar(t("patient-care.new-period-planning-add-error"), { variant: 'error' });
      }
    }

    // Parent'a seçilen saati bildir
    if (setDialogTreeOpen) {
      setDialogTreeOpen(false); // Modalı kapat
    }
    // Seçilen saati parent'a gönder
    if (onTimeSelected) {
      onTimeSelected(time, pcsid);
    }
  };

  const handleHalfHourClick = () => {
  };

  const handleClose = () => {
    setDialogTreeOpen(false);
  };

  return (
    <Box
      sx={{
        width: { xs: "12", sm: "12" },
        backgroundColor: "#FFF",
      }}
    >
      {(!newPlan || (newPlan && selectedPlan)) ? (
        <Box sx={{ marginBottom: 1, border: "none" }}>
          <ByzMuiTypography
            fontWeight="bold"
            variant="body1"
            sx={{ display: "inline", whiteSpace: "nowrap" }}
          >
            {newPlan ? t("patient-care.to-be-planned-guide") : t("patient-care.selected-guide")}
          </ByzMuiTypography>
          <ByzMuiTypography
            variant="body2"
            sx={{ display: "inline", marginLeft: 1 }}
          >
            {selectedPlan || t("patient-care.guide-not-selected")}
          </ByzMuiTypography>
          <Box sx={{ marginBottom: 1, border: "none" }}>
            <ByzMuiTypography
              fontWeight="bold"
              variant="body1"
              sx={{ display: "inline", whiteSpace: "nowrap" }}
            >
              {newPlan ? t("patient-care.current-period") : t("patient-care.selected-period")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body2"
              sx={{ display: "inline", marginLeft: 1 }}
            >
              {currentPeriod && !Number.isNaN(Number(currentPeriod)) ? `${Math.round(Number(currentPeriod) / 60)} ${t("hour")}` : t("patient-care.period-not-determined")}
            </ByzMuiTypography>
          </Box>
          <Divider sx={{ margin: "16px 0" }} />
        </Box>
      ) : null}
      <Box
        onClick={handleHalfHourClick}
        sx={{ cursor: "pointer", marginBottom: 2 }}
      ></Box>
      <List>
        {["Yarım Saat", 1, 2, 3, 4, 6, 8, 12, 24].map((item) => (
          <ListItem
            key={item}
            sx={{
              padding: 1,
              cursor: "pointer",
              backgroundColor:
                selectedTime === item ? "#f0f0f0" : "transparent",
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            }}
            onClick={() => handleTimeClick(item === 'Yarım Saat' ? 0.5 : item)}
          >
            <ByzMuiTypography variant="body1">{item}</ByzMuiTypography>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ marginTop: 2 }} />
      <ByzMuiTypography
        variant="subtitle2"
        gutterBottom
        onClick={handleClose}
        sx={{ cursor: "pointer", textAlign: "center", color: "#1976d2" }}
      >
        {t("open-process-menu.close")}
      </ByzMuiTypography>
    </Box>
  );
};

export default PatientCareNursePlanAdd;
